'use client';

import { useRouter } from 'next/navigation';
import { asText, RichTextField } from '@prismicio/client';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { Link } from '@preventx/oxygen';

type BackProps = {
  label: RichTextField;
};

/** **Important** : This component is specifically designed to navigate back in the page history
 *                  so do not alter the default configuration as you may break pages using this
 *                  component. */
export const Back = ({ label }: BackProps) => {
  const router = useRouter();

  return (
    <Link
      href="#"
      addSubtle
      type="link"
      as="default"
      onClick={() => router.back()}
      icon={{ definition: faArrowLeft, position: 'left' }}
    >
      {asText(label)}
    </Link>
  );
};
